import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from '@/components/common/SubtleBadge';
 

const CrawlStatusError = (): React.JSX.Element => {
  return (
    <SubtleBadge pill bg="danger" className="d-block  fs--2">
      <FontAwesomeIcon icon="ban" transform="shrink-2" className="mx-1" />
      خطا
    </SubtleBadge>
  );
};

export default CrawlStatusError;
